import template from './fundingObligationBulkImportModal.html';
import controller from './fundingObligationBulkImportModal.controller';

let FundingObligationBulkImportModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: 'hmodal-info animated zoomIn'
};

FundingObligationBulkImportModalComponent.template = template;
FundingObligationBulkImportModalComponent.controller = controller;

export default FundingObligationBulkImportModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/fundingObligationBulkImportModal/fundingObligationBulkImportModal.component.js